import { AvatarSize, Box, Text } from '@bechtel/gds';
import { useProjectConfiguration } from '@bechtel/ht-clients-common';
import { Requisition } from '@bechtel/ht-types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from '~/components';
import UserPhoto from '~/components/molecules/user-photo';
import { SecondaryTextStyled, TeritaryTextStyled } from '~/styles';
import { ReqItemCardStyled, StatusBarStyled } from './styled';

interface RequisitionHistoryListItemProps {
  requisition: Requisition;
  selected: boolean;
}

const RequisitionHistoryListItem: FC<RequisitionHistoryListItemProps> = ({ requisition, selected }) => {
  const { t } = useTranslation();
  const { formattedDateTime } = useProjectConfiguration();
  const navigate = useNavigate();
  return (
    <ErrorBoundary>
      <ReqItemCardStyled selected={selected} onClick={() => navigate(requisition.id)}>
        <Box style={{ position: 'relative' }}>
          <StatusBarStyled fillColor="green.500" />
          <Box
            flexDirection={{ sm: 'column' }}
            pl={{ sm: '500' }}
            pr={{ sm: '450' }}
            py={{ sm: '300' }}
            style={{ width: '100%' }}
          >
            <Box justifyContent={{ sm: 'space-between' }}>
              <Box flexDirection={{ sm: 'column' }} gap={{ sm: '300' }}>
                <SecondaryTextStyled weight="600">{requisition?.requisitionNumber || ''}</SecondaryTextStyled>
                <Box mb={{ sm: '400' }}>
                  <Box alignItems={{ sm: 'center' }}>
                    <Text family="openSansCondensed" size={300}>
                      {t('CONSUMABLES')}:
                    </Text>
                    <Text size={300} color="grey.600">
                      {requisition.nonSerializedCount}
                    </Text>
                  </Box>
                  <Box alignItems={{ sm: 'center' }} ml={{ sm: '400' }}>
                    <Text family="openSansCondensed" size={300}>
                      {t('Tools')}:
                    </Text>
                    <Text size={300} color="grey.600">
                      {requisition.serializedCount}
                    </Text>
                  </Box>
                </Box>
                <TeritaryTextStyled size="250">{formattedDateTime(requisition.updatedDate)}</TeritaryTextStyled>
              </Box>
              <Box mr={{ sm: '400' }} flexDirection={{ sm: 'column' }}>
                <UserPhoto imageUrl={''} size={AvatarSize.MEDIUM} />
                <Text size="200" color="grey.600" transform="capitalize" style={{ lineHeight: '1.8' }}>
                  {requisition?.createdBy.toLowerCase() ?? ''}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        {/* {requisition.createdByUser && (
          <Box flexDirection={{ sm: 'column' }} gap={{ sm: '100' }} style={{ flex: '1' }}>
            <UserDetail item={requisition.createdByUser} hideIcon={true} />
          </Box>
        )} */}
      </ReqItemCardStyled>
    </ErrorBoundary>
  );
};

export default RequisitionHistoryListItem;
